import AbstractService from '@/services/abstractService'

class SettingsService extends AbstractService {
  transferEndpoint = 'contract/transferRequests'

  cancelEndpoint = 'contract/cancelRequests'

  transferRequests() {
    return this.http.get(this.transferEndpoint)
  }

  cancelRequests() {
    return this.http.get(this.cancelEndpoint)
  }

  changeTransferStatus(requestId) {
    return this.http.post(`contracts/requests/transfer/${requestId}/status`)
  }

  changeCancelStatus(requestId) {
    return this.http.post(`contracts/requests/cancel/${requestId}/status`)
  }
}

const Service = new SettingsService()

export default Service
